import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import Box from "@memorang/ui/src/components/Box";
import type { IconType } from "@memorang/ui/src/types";
import { List, RadioButton } from "react-native-paper";
import type { SortByDataType, SortOrderType } from "./types";
import type { SortBy } from "./types";

type SortViewMainContentProps = {
	handleSortByChange: (type: SortBy) => void;
	data: SortByDataType[];
	selectedSortByItem?: SortByDataType;
	sortOrderType: SortOrderType;
};

const SortViewMainContent = ({
	handleSortByChange,
	data,
	selectedSortByItem,
	sortOrderType,
}: SortViewMainContentProps) => {
	return (
		<Box>
			{data.map((item) => (
				<List.Item
					key={item.label}
					title={item.label}
					onPress={() => handleSortByChange(item.type)}
					left={(props) => {
						return (
							<List.Icon
								{...props}
								icon={() => <Icon name={item.icon as IconType} size={24} />}
							/>
						);
					}}
					right={(props) => {
						const isSelected = item.type === selectedSortByItem?.type;
						return (
							<List.Icon
								{...props}
								icon={() => {
									return (
										<Box flexDirection="row" alignItems="center" gap={8}>
											{isSelected && (
												<Icon
													name={
														sortOrderType === "asc"
															? "sort-ascending"
															: "sort-descending"
													}
													size={24}
												/>
											)}
											<RadioButton.Android
												value={item.type}
												onPress={() => handleSortByChange(item.type)}
												status={isSelected ? "checked" : "unchecked"}
											/>
										</Box>
									);
								}}
							/>
						);
					}}
				/>
			))}
		</Box>
	);
};

export default SortViewMainContent;
